import { useState, useEffect, Fragment } from 'react'

import TypeWriter from './typeWriter'
import { TypeWriterParagraphProps } from './typeWriter.types'

const TypeWriterParagraph = ({ textList, onFinishTyping }:TypeWriterParagraphProps) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [elements, setElements] = useState<React.ReactNode[]>([]);

  const next = () => {
    if (currentTextIndex < textList.length - 1) {
        return setCurrentTextIndex((prev) => prev + 1)
    }

    return onFinishTyping?.()
  }

  useEffect(() => {
      setElements((prev) => [
        ...prev, 
        <div key={`${textList[currentTextIndex]}-${currentTextIndex}`}>
          <TypeWriter text={textList[currentTextIndex]} onFinishTyping={next} />
        </div>
      ])
  }, [currentTextIndex])

  return <>{elements.map((element, i) => <Fragment key={`${element}-${i}`}>{element}</Fragment>)}</>
}

export default TypeWriterParagraph